export type AkahuBankListItem = {
  name: string;
  logoUrl?: string | null;
};

type AkahuSupportedBanksProps = {
  banks: AkahuBankListItem[];
  /** Intro copy above the bank chips. */
  description?: string;
  loading?: boolean;
  className?: string;
  compact?: boolean;
};

const AkahuSupportedBanks = ({
  banks,
  description,
  loading = false,
  className,
  compact = false,
}: AkahuSupportedBanksProps) => {
  return (
    <div className={className ?? "space-y-2"}>
      {description && (
        <p className={compact ? "text-xs text-gray-600" : "text-sm text-gray-700"}>{description}</p>
      )}
      {loading ? (
        <p className="text-xs text-gray-500">Loading supported banks…</p>
      ) : (
        <ul className="flex flex-wrap gap-2">
          {banks.map((bank) => (
            <li
              key={bank.name}
              className="inline-flex items-center gap-2 rounded border border-gray-200 bg-white px-2.5 py-1.5 text-xs text-gray-800"
            >
              {bank.logoUrl ? (
                <img src={bank.logoUrl} alt="" className="h-4 w-4 object-contain" loading="lazy" />
              ) : null}
              <span>{bank.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export { AkahuSupportedBanks };
